import { render, staticRenderFns } from "./AgentHome.vue?vue&type=template&id=0c6f9c64&scoped=true"
import script from "./AgentHome.vue?vue&type=script&lang=js"
export * from "./AgentHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6f9c64",
  null
  
)

export default component.exports